export default {
    tools: ({tools}) => tools,
}